// @flow

import table from './table';

const system = {};

system.table = table;

export default system;
